
import Component from 'vue-class-component';
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { LoanDetails } from '@/loan/types/loan-details';
import { LoanStatus } from '@/loan/enums/loan-status';
import LoanNavOverview from './LoanNavOverview.vue';
import LoanNavActivity from './LoanNavActivity.vue';
import LoanNavHelpCenter from './LoanNavHelpCenter.vue';

const loanNamespace = namespace('loan');

@Component({
	components: {
		LoanNavOverview,
		LoanNavActivity,
		LoanNavHelpCenter,
	},
})
export default class LoanNav extends Vue {
	@loanNamespace.State('loanDetails')
	public loanDetails!: LoanDetails;

	@loanNamespace.Getter('loanId')
	public loanId!: string | undefined;

	@loanNamespace.Getter('status')
	public status!: LoanStatus;
}

